import React from 'react';
import PageList from '../../../components/PageListAPI'
import { getRegions, deleteRegions } from '../../../api/list'
import { useHistory, useLocation } from 'react-router-dom'

export default function RegionList() {
  const location = useLocation()
  const history = useHistory()
  return (
    <div className='App-paper'>
      <PageList
        name='region-list'
        columns={[{ id: 'name', name: 'Название' }]}
        createItem={true}
        deleteItem={true}
        loadAPI={{
          request: getRegions,
        }}
        deleteAPI={deleteRegions}
        pagination={false}
        tableProps={{
          pagination: false,
        }}
        location={location}
        history={history}
      />
    </div>
  )
};